/**
 * How an age reads on a card.
 *
 * The identity line is a bare join — "Mother · Florida · 34" — so an age with
 * no unit is only legible because a number in the thirties can't be much else.
 * At the bottom of the range that breaks down: a plan card reading
 * "Florida · 0" beside three chronic diagnoses looks like a field that failed
 * to load, not like a person's age. That was a real report.
 *
 * Zero is not suppressed. This is a care-coordination app and infant plans are
 * real; hiding a legitimate age is worse than an ambiguous one. It is spelled
 * "under 1" instead, because "0 yrs" is how a null renders, not how anyone
 * describes a baby.
 *
 * Takes a computed age rather than a birthday: the two callers derive it
 * differently (a strict ISO parse in CarePlanCard, a Date round-trip in
 * IntakePendingCard) and unifying those is a separate change with its own
 * edge cases.
 */
export function describeAge(age: number): string {
  if (!Number.isFinite(age) || age < 0) return '';
  if (age === 0) return 'under 1';
  return `${age} yr${age === 1 ? '' : 's'}`;
}
